import { render } from "./AppTop.vue?vue&type=template&id=3d494774"
import script from "./AppTop.vue?vue&type=script&lang=js"
export * from "./AppTop.vue?vue&type=script&lang=js"

import "./AppTop.vue?vue&type=style&index=0&id=3d494774&lang=css"
script.render = render

export default script